import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

import RecepcionStatus from '../../../support/enum/RecepcionStatus';

class RecepcionStatusBadge extends Component {

  get config() {
    const { valid } = this.props;

    const recepcion = RecepcionStatus.search(valid) ?? RecepcionStatus.undefined();

    let variant = '';
    let text = '';

    if (recepcion?.isInvalid()) {
      variant = 'danger';
      text = 'invalid';
    } else if (recepcion?.isValid()) {
      variant = 'success';
      text = 'valid';
    }

    return {
      variant,
      text
    }
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        { text }
      </Badge>
    )
  }
}

export default RecepcionStatusBadge;